import React, { useState } from 'react';
import CTASection from '../components/CTASection';
import ThinkDreamSection from '../components/ThinkDreamSection';
import CharactersLocationsSection from '../components/CharactersLocationsSection';
import UIBeats from '../components/UIBeats';
import '../styles/ProductOutline.css';
import '../styles/Home.css';

const ProductOutline = () => {
  const [activeTab, setActiveTab] = useState('beats');
  return (
    <div className="product-page">
      <section
        className="hero"
      >
        <div className="container">
          <label>Outline</label>
          <h1 className="hero-title">Define the direction of your story</h1>
          <p className="hero-subtitle">
            Move your story from start to finish with an intuitive canvas and timeline, that works the way you do.
          </p>
        </div>
        <div className="fake-hero-beat-container">
          <div className="fake-hero-beat hero-beat-1"></div>
          <div className="fake-hero-beat hero-beat-2"></div>
          <div className="fake-hero-beat hero-beat-3"></div>
          <div className="fake-hero-beat hero-beat-4"></div>
        </div>
      </section>
      <UIBeats selectedTab={activeTab} onTabChange={setActiveTab} pageClassName="ui-script-product-outline" />
      <section className="section-marg two-column-section">
        <div className="two-column-container">
          <div className="two-column-item">
            <h2 className="section-title">Extremely easy to use</h2>
            <p className="section-subtitle">Built for fluid thinking, the canvas lets you create, change, reorder, and expand your beats effortlessly.</p>
            <div className="grey">
              <div className="hero-beat green">
                <div className="flex flex-column gap-8">
                  <p>Hidden Hours</p>
                  <div className="flex flex-column gap-8">
                    <div className="hero-beat-placeholder"></div>
                    <div className="hero-beat-placeholder w-80"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="act-chip">Act 1</div>
                  <div className="sequence-chip">The routine</div>
                </div>
              </div>
              <div className="right-click-popout">
                <div className="fake-ui-sidebar-item selected">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1233_9846)">
                        <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="2.80357" stroke="#272729" stroke-width="1.25" />
                        <path d="M4 12.4285H6" stroke="#272729" stroke-width="1.25" stroke-linecap="round" />
                        <path d="M8.59998 12.4285H10.6" stroke="#272729" stroke-width="1.25" stroke-linecap="round" />
                      </g>
                    </svg>
                    <p>Appearance</p>
                  </div>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99158 7.00003L4.99158 4.35574C4.99158 3.62513 5.86495 3.24813 6.39657 3.74943L9.20127 6.39369C9.55017 6.72263 9.55017 7.27743 9.20127 7.60637L6.39658 10.2507C5.86495 10.7519 4.99158 10.375 4.99158 9.64433L4.99158 7.00003Z" fill="black" />
                  </svg>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1233_9581)">
                        <path d="M15.3501 8.35207C15.3501 11.3928 14.1216 13.6315 11.8299 14.6074C10.0657 15.3587 7.75193 14.5672 7.35333 12.6916C7.02653 11.1538 7.65515 9.85055 6.10329 8.8101C4.87438 8.16447 4.07944 8.914 3.16146 9.24617C1.23048 9.94488 0.149391 6.99646 0.939982 5.10125C2.07844 2.37213 4.74245 0.85083 7.84891 0.85083C11.9917 0.85083 15.3501 4.20925 15.3501 8.35207Z" stroke="black" strokeWidth="1.25" />
                        <path d="M7.75445 4.63463C8.28142 4.63463 8.70861 4.20744 8.70861 3.68048C8.70861 3.15351 8.28142 2.72632 7.75445 2.72632C7.22748 2.72632 6.80029 3.15351 6.80029 3.68048C6.80029 4.20744 7.22748 4.63463 7.75445 4.63463Z" fill="black" />
                        <path d="M10.5694 5.40538C11.0964 5.40538 11.5235 4.97819 11.5235 4.45123C11.5235 3.92426 11.0964 3.49707 10.5694 3.49707C10.0424 3.49707 9.61523 3.92426 9.61523 4.45123C9.61523 4.97819 10.0424 5.40538 10.5694 5.40538Z" fill="black" />
                        <path d="M12.1452 7.79967C12.6722 7.79967 13.0994 7.37248 13.0994 6.84551C13.0994 6.31855 12.6722 5.89136 12.1452 5.89136C11.6182 5.89136 11.191 6.31855 11.191 6.84551C11.191 7.37248 11.6182 7.79967 12.1452 7.79967Z" fill="black" />
                        <path d="M12.5639 10.5812C13.0909 10.5812 13.5181 10.154 13.5181 9.62701C13.5181 9.10004 13.0909 8.67285 12.5639 8.67285C12.0369 8.67285 11.6097 9.10004 11.6097 9.62701C11.6097 10.154 12.0369 10.5812 12.5639 10.5812Z" fill="black" />
                        <path d="M10.6558 12.7399C11.1828 12.7399 11.61 12.3127 11.61 11.7857C11.61 11.2587 11.1828 10.8315 10.6558 10.8315C10.1289 10.8315 9.70166 11.2587 9.70166 11.7857C9.70166 12.3127 10.1289 12.7399 10.6558 12.7399Z" fill="black" />
                      </g>
                    </svg>
                    <p>Color options</p>
                  </div>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99158 7.00003L4.99158 4.35574C4.99158 3.62513 5.86495 3.24813 6.39657 3.74943L9.20127 6.39369C9.55017 6.72263 9.55017 7.27743 9.20127 7.60637L6.39658 10.2507C5.86495 10.7519 4.99158 10.375 4.99158 9.64433L4.99158 7.00003Z" fill="black" />
                  </svg>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.86362 3L13.5 6.63636M13.5 6.63636L9.86362 10.2727M13.5 6.63636H6.89392C4.68478 6.63636 2.89392 8.42722 2.89392 10.6364V13" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <p>Move to</p>
                  </div>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99158 7.00003L4.99158 4.35574C4.99158 3.62513 5.86495 3.24813 6.39657 3.74943L9.20127 6.39369C9.55017 6.72263 9.55017 7.27743 9.20127 7.60637L6.39658 10.2507C5.86495 10.7519 4.99158 10.375 4.99158 9.64433L4.99158 7.00003Z" fill="black" />
                  </svg>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.8509 5.28298V6.56147H10.3815V5.28298H14.8509ZM11.5801 3.32263H13.1728V11.0628C13.1728 11.3718 13.219 11.6044 13.3113 11.7607C13.4037 11.9134 13.5226 12.0181 13.6683 12.075C13.8174 12.1282 13.979 12.1549 14.153 12.1549C14.2809 12.1549 14.3927 12.146 14.4886 12.1282C14.5845 12.1105 14.6591 12.0963 14.7124 12.0856L15 13.4014C14.9077 13.4369 14.7763 13.4724 14.6058 13.5079C14.4353 13.547 14.2223 13.5683 13.9666 13.5719C13.5475 13.579 13.1569 13.5044 12.7946 13.3481C12.4324 13.1919 12.1394 12.9504 11.9157 12.6236C11.6919 12.2969 11.5801 11.8867 11.5801 11.3931V3.32263Z" fill="black" />
                      <path d="M1 3.97253V2.55554H9.44336V3.97253H6.03938V13.4653H4.39865V3.97253H1Z" fill="black" />
                    </svg>
                    <p>Add to sequence</p>
                  </div>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99158 7.00003L4.99158 4.35574C4.99158 3.62513 5.86495 3.24813 6.39657 3.74943L9.20127 6.39369C9.55017 6.72263 9.55017 7.27743 9.20127 7.60637L6.39658 10.2507C5.86495 10.7519 4.99158 10.375 4.99158 9.64433L4.99158 7.00003Z" fill="black" />
                  </svg>
                </div>
                <div className="divider"></div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1233_9593)">
                        <path d="M2.65381 4.16089L3.63393 13.2152C3.74383 14.2306 4.60105 15 5.62231 15H7.98989" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.3201 4.16089L12.2486 13.2345C12.1297 14.2414 11.2762 15 10.2624 15H7.98706" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.82129 4.15462V3C5.82129 1.89543 6.71672 1 7.82129 1H8.15189C9.25646 1 10.1519 1.89543 10.1519 3V4.15462" stroke="black" strokeWidth="1.25" />
                        <path d="M1.15991 4.15991H14.813" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                      </g>
                    </svg>
                    <p>Delete beat</p>
                  </div>
                </div>
              </div>
              <div className="right-click-popout second">
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1233_9846)">
                        <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="2.80357" stroke="#272729" stroke-width="1.25" />
                        <path d="M4 12.4285H6" stroke="#272729" stroke-width="1.25" stroke-linecap="round" />
                        <path d="M8.59998 12.4285H10.6" stroke="#272729" stroke-width="1.25" stroke-linecap="round" />
                      </g>
                    </svg>
                    <p>Label only</p>
                  </div>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.76613 1.22345C10.0122 1.44519 10.0364 1.82271 9.82065 2.07405L3.86384 9.0148C3.50047 9.43819 2.83228 9.39373 2.52821 8.92593L0.608192 5.97206C0.384495 5.62791 0.470767 5.16872 0.804116 4.92923C1.12457 4.699 1.56732 4.74891 1.82849 5.0447L3.36997 6.79058C3.38999 6.81325 3.42503 6.81424 3.4463 6.79271L8.92358 1.2479C9.15277 1.01589 9.52388 1.00512 9.76613 1.22345Z" fill="#272729" />
                  </svg>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1233_9853)">
                        <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="2.80357" stroke="#272729" stroke-width="1.25" />
                        <path d="M0.817139 4.08018C0.817139 2.58793 1.78233 1.26705 3.20404 0.813678L4.00546 0.558105V15.4571L3.1897 15.193C1.77528 14.7351 0.817139 13.4178 0.817139 11.9312V4.08018Z" fill="#272729" />
                      </g>
                    </svg>
                    <p>Border</p>
                  </div>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1235_9882)">
                        <rect width="16" height="16" rx="3.42857" fill="#272729" />
                        <path d="M4 12.4285H6" stroke="white" stroke-width="1.25" stroke-linecap="round" />
                        <path d="M8.5 12.4285H10.5" stroke="white" stroke-width="1.25" stroke-linecap="round" />
                        <path d="M4 4.57153H10.8571M4 7.42868H8" stroke="white" stroke-width="1.25" stroke-linecap="round" />
                      </g>
                    </svg>
                    <p>Full color</p>
                  </div>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2223_2636)">
                        <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="2.80357" stroke="#272729" stroke-width="1.25" />
                      </g>
                    </svg>
                    <p>Clean</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="two-column-divider"></div>
          <div className="two-column-item">
            <h2 className="section-title">Always in sync</h2>
            <p className="section-subtitle">Every change you make in your outline, automatically flows right into your timeline.</p>
            <div className="grey cloud">
              <div className="hero-beat purple">
                <div className="flex flex-column gap-8">
                  <p>The Long Walk Back</p>
                  <div className="flex flex-column gap-8">
                    <div className="hero-beat-placeholder"></div>
                    <div className="hero-beat-placeholder w-80"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="act-chip">Act 1</div>
                  <div className="sequence-chip">Add to sequence</div>
                </div>
              </div>
              <div className="right-click-popout">
                <div className="fake-ui-sidebar-item selected">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 2V14" stroke="#272729" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                    <p>Act I</p>
                  </div>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 2V14" stroke="#272729" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M6 2V14" stroke="#272729" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                    <p>Act 2</p>
                  </div>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 2V14" stroke="#272729" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M12 2V14" stroke="#272729" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M4 2V14" stroke="#272729" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                    <p>Act 3</p>
                  </div>
                </div>
                <div className="fake-ui-sidebar-item">
                  <div className="flex flex-row gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="6.375" stroke="#272729" stroke-width="1.25" />
                      <path d="M12.375 3.625L3.625 12.375" stroke="#272729" stroke-width="1.25" stroke-linecap="round" />
                    </svg>
                    <p>Unassigned</p>
                  </div>
                </div>
              </div>
              <img src={`${process.env.PUBLIC_URL}/images/sync.jpg`} alt="Export" className="section-image-large" />
            </div>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      <section className="section-marg three-column-section outline-section">
        <h2 className="section-title wide-section-title">Multiple ways of working</h2>
        <p className="section-subtitle">Move between Canvas, Kanban, and List View to organize your story in whatever way feels right.</p>
        <div className="three-column-grid">
          <div className="three-column-item">
            <div className="ui-square-container bordered">
              <div className="ui-square hero-beat blurple">
                <div className="flex flex-column gap-8">
                  <div className="flex flex-column gap-8">
                    <div className="hero-beat-placeholder"></div>
                    <div className="hero-beat-placeholder"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="act-chip">Act 1</div>
                  <div className="sequence-chip">Shay Runs Away</div>
                </div>
              </div>
              <div className="ui-square hero-beat none">
                <div className="flex flex-column gap-8">
                  <p>Magnum Opus</p>
                  <div className="flex flex-column gap-8">
                    <div className="hero-beat-placeholder"></div>
                    <div className="hero-beat-placeholder w-80"></div>
                    <div className="hero-beat-placeholder w-90"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="act-chip">Act 2</div>
                  <div className="sequence-chip">No Turning Back</div>
                </div>
              </div>
              <div className="ui-square hero-beat orange">
                <div className="flex flex-column gap-8">
                  <p>The Magnetic Field</p>
                  <div className="flex flex-column gap-8">
                    <div className="hero-beat-placeholder"></div>
                    <div className="hero-beat-placeholder"></div>
                    <div className="hero-beat-placeholder"></div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="act-chip">Act 2</div>
                  <div className="sequence-chip">No Turning Back</div>
                </div>
              </div>
            </div>
            <div className="section-features">
              <div className="section-feature">
                <div className="section-title-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2.5" y="2.5" width="13" height="13" rx="2.5" stroke="#272729" />
                    <rect x="7.5" y="7.5" width="8" height="8" rx="2.5" stroke="#272729" />
                  </svg>
                  <p>Canvas</p>
                </div>
                <div className="section-feature-text">
                  <p>Let’s you outline your story in a free flowing and creative manner. </p>
                </div>
              </div>
            </div>
          </div>
          <div className="three-column-item">
            <div className="ui-square-container bordered">
              <div className="ui-kanban-container">
                <div className="ui-kanban-header">
                  <div className="flex gap-8 items-center">
                    <div className="ui-kanban-square purple"></div>
                    <p>Act 1</p>
                  </div>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.4">
                      <path d="M8 4V12" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M4 8L12 8" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                    </g>
                  </svg>
                </div>
                <div className="ui-kanban-column">
                  <div className="flex gap-8 items-center">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.8507 5.28298V6.56147H10.3813V5.28298H14.8507ZM11.5799 3.32263H13.1727V11.0628C13.1727 11.3718 13.2189 11.6044 13.3112 11.7607C13.4036 11.9134 13.5225 12.0181 13.6681 12.075C13.8173 12.1282 13.9789 12.1549 14.1529 12.1549C14.2807 12.1549 14.3926 12.146 14.4885 12.1282C14.5844 12.1105 14.659 12.0963 14.7122 12.0856L14.9999 13.4014C14.9076 13.4369 14.7762 13.4724 14.6057 13.5079C14.4352 13.547 14.2221 13.5683 13.9664 13.5719C13.5474 13.579 13.1567 13.5044 12.7945 13.3481C12.4323 13.1919 12.1393 12.9504 11.9155 12.6236C11.6918 12.2969 11.5799 11.8867 11.5799 11.3931V3.32263Z" fill="#272729" />
                      <path d="M1 3.97254V2.55554H9.44336V3.97254H6.03938V13.4653H4.39865V3.97254H1Z" fill="#272729" />
                    </svg>
                    <p className="font-medium">Shay runs away</p>
                  </div>
                  <div className="ui-kanban-beat">
                    <div className="flex flex-column gap-8">
                      <p>Finding shelter</p>
                      <div className="flex flex-column gap-8">
                        <div className="hero-beat-placeholder"></div>
                        <div className="hero-beat-placeholder w-80"></div>
                      </div>
                    </div>
                  </div>
                  <div className="ui-kanban-beat empty"></div>
                  <div className="ui-kanban-beat floating">
                    <div className="flex flex-column gap-8">
                      <p>Out of Sight</p>
                      <div className="flex flex-column gap-8">
                        <div className="hero-beat-placeholder"></div>
                        <div className="hero-beat-placeholder w-60"></div>
                      </div>
                    </div>
                  </div>
                  <div className="ui-kanban-beat">
                    <div className="flex flex-column gap-8">
                      <p>Francis</p>
                      <div className="flex flex-column gap-8">
                        <div className="hero-beat-placeholder"></div>
                        <div className="hero-beat-placeholder w-70"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="section-features">
              <div className="section-feature">
                <div className="section-title-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2.5" y="2.5" width="5" height="3" rx="0.5" stroke="#272729" />
                    <rect x="10.5" y="2.5" width="5" height="3" rx="0.5" stroke="#272729" />
                    <rect x="10.5" y="7.5" width="5" height="3" rx="0.5" stroke="#272729" />
                    <rect x="10.5" y="12.5" width="5" height="3" rx="0.5" stroke="#272729" />
                    <rect x="2.5" y="7.5" width="5" height="3" rx="0.5" stroke="#272729" />
                    <rect x="2.5" y="12.5" width="5" height="3" rx="0.5" stroke="#272729" />
                  </svg>
                  <p>Kanban</p>
                </div>
                <div className="section-feature-text">
                  <p>Makes it easy to shift beats and sequences around as your story takes shape.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="three-column-item">
            <div className="ui-square-container bordered">
              <div className="ui-list-container">
                <div className="ui-list-header">
                  <div className="ui-list-header-left">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.25">
                        <path d="M6 4.49368L7.98322 4.49368C8.53121 4.49368 8.81389 5.14871 8.43798 5.54743L6.45475 7.65095C6.20805 7.91263 5.79195 7.91263 5.54525 7.65095L3.56202 5.54743C3.18611 5.14871 3.46879 4.49368 4.01678 4.49368L6 4.49368Z" fill="#272729" />
                      </g>
                    </svg>
                  </div>
                  <div className="flex gap-8 items-center">
                    <div className="ui-list-square green"></div>
                    <p>Act 1</p>
                  </div>
                </div>
                <div className="ui-list-item list-beat flex gap-8 items-center">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.54688" y="1.54688" width="12.9062" height="12.9062" rx="2.45312" stroke="#272729" stroke-width="1.09375" />
                    <path d="M4.5 5.00012H10.5M4.5 7.50012H8" stroke="#272729" stroke-width="1.09375" stroke-linecap="round" />
                  </svg>
                  <p>Faded Sunrise</p>
                </div>
                <div className="ui-list-item list-beat flex gap-8 items-center">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.54688" y="1.54688" width="12.9062" height="12.9062" rx="2.45312" stroke="#272729" stroke-width="1.09375" />
                    <path d="M4.5 5.00012H10.5M4.5 7.50012H8" stroke="#272729" stroke-width="1.09375" stroke-linecap="round" />
                  </svg>
                  <p>Mariah</p>
                </div>
                <div className="ui-list-item list-beat flex gap-8 items-center">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.54688" y="1.54688" width="12.9062" height="12.9062" rx="2.45312" stroke="#272729" stroke-width="1.09375" />
                    <path d="M4.5 5.00012H10.5M4.5 7.50012H8" stroke="#272729" stroke-width="1.09375" stroke-linecap="round" />
                  </svg>
                  <p>A lost Letter</p>
                </div>
                <div className="ui-list-item list-beat flex gap-8 items-center">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.8507 5.28298V6.56147H10.3813V5.28298H14.8507ZM11.5799 3.32263H13.1727V11.0628C13.1727 11.3718 13.2189 11.6044 13.3112 11.7607C13.4036 11.9134 13.5225 12.0181 13.6681 12.075C13.8173 12.1282 13.9789 12.1549 14.1529 12.1549C14.2807 12.1549 14.3926 12.146 14.4885 12.1282C14.5844 12.1105 14.659 12.0963 14.7122 12.0856L14.9999 13.4014C14.9076 13.4369 14.7762 13.4724 14.6057 13.5079C14.4352 13.547 14.2221 13.5683 13.9664 13.5719C13.5474 13.579 13.1567 13.5044 12.7945 13.3481C12.4323 13.1919 12.1393 12.9504 11.9155 12.6236C11.6918 12.2969 11.5799 11.8867 11.5799 11.3931V3.32263Z" fill="#272729" />
                    <path d="M1 3.97254V2.55554H9.44336V3.97254H6.03938V13.4653H4.39865V3.97254H1Z" fill="#272729" />
                  </svg>
                  <p>Life in shadows</p>
                </div>

                <div className="ui-list-item list-beat flex gap-8 items-center">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.54688" y="1.54688" width="12.9062" height="12.9062" rx="2.45312" stroke="#272729" stroke-width="1.09375" />
                    <path d="M4.5 5.00012H10.5M4.5 7.50012H8" stroke="#272729" stroke-width="1.09375" stroke-linecap="round" />
                  </svg>
                  <p>Train Window</p>
                </div>
                <div className="ui-list-item list-beat flex gap-8 items-center">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.54688" y="1.54688" width="12.9062" height="12.9062" rx="2.45312" stroke="#272729" stroke-width="1.09375" />
                    <path d="M4.5 5.00012H10.5M4.5 7.50012H8" stroke="#272729" stroke-width="1.09375" stroke-linecap="round" />
                  </svg>
                  <p>Old Photographs</p>
                </div>
                <div className="sequence-wrapper">
                  <div className="sequence-dot"></div>
                  <div className="sequence-bar"></div>
                </div>
              </div>
            </div>
            <div className="section-features">
              <div className="section-feature">
                <div className="section-title-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="2.5" width="18" height="1" rx="0.5" fill="#272729" />
                    <rect y="6.5" width="18" height="1" rx="0.5" fill="#272729" />
                    <rect y="10.5" width="18" height="1" rx="0.5" fill="#272729" />
                    <rect y="14.5" width="18" height="1" rx="0.5" fill="#272729" />
                  </svg>
                  <p>List</p>
                </div>
                <div className="section-feature-text">
                  <p>Gives you a clear, linear overview of your story, from top to bottom. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      <CharactersLocationsSection />

      <div className="divider"></div>

      <ThinkDreamSection />

      <div className="divider"></div>

      <CTASection />
    </div>
  );
};

export default ProductOutline;


